class ProductAddons extends PopupBase {
  constructor() {
    super();
    this.productPopupDiv = this.querySelector(".product-addons__content");
    this.init();
  }
  init() {
    if (this.productPopupDiv) {
      this.addEventListener("click", this.onClick.bind(this));
      this.addEventListener("keydown", this.onKeydown.bind(this));
    }
  }
  onKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.onClick();
    }
  }
  onClick() {
    const html = this.productPopupDiv;
    if (!html) return;
    const lazyImages = html.querySelectorAll("img[data-src]");
    lazyImages.forEach((img) => {
      if (img.dataset.loaded === "true") return;
      img.src = img.dataset.src;
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }
      img.dataset.loaded = "true";
    });
    html.classList.remove("hidden");
    const headerText = this.dataset?.textHeader;
    const header = headerText
      ? `<h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">${headerText}</h3>`
      : "";
    this.initPopup(
      html,
      header,
      this.dataset?.customClass
    );
  }
}
customElements.define("product-addons", ProductAddons);
